var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 65,
    viewBox: "0 0 51 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 0C18.7394 0.00797563 12.258 2.69713 7.4776 7.47758C2.69716 12.258 0.00800276 18.7394 2.71294e-05 25.5C-0.00807002 31.0247 1.79657 36.3995 5.13711 40.7999C5.13711 40.7999 5.83257 41.7156 5.94616 41.8478L25.5 64.909L45.0631 41.8362C45.1651 41.7133 45.8629 40.7999 45.8629 40.7999L45.8652 40.793C49.2041 36.3945 51.0079 31.0222 51 25.5C50.992 18.7394 48.3028 12.258 43.5224 7.47758C38.7419 2.69713 32.2606 0.00797563 25.5 0V0ZM25.5 34.7727C23.666 34.7727 21.8732 34.2288 20.3484 33.2099C18.8235 32.191 17.635 30.7429 16.9331 29.0485C16.2313 27.3541 16.0477 25.4897 16.4055 23.691C16.7632 21.8922 17.6464 20.24 18.9432 18.9432C20.24 17.6464 21.8923 16.7632 23.691 16.4054C25.4897 16.0476 27.3541 16.2313 29.0485 16.9331C30.7429 17.6349 32.1911 18.8234 33.21 20.3483C34.2289 21.8732 34.7727 23.666 34.7727 25.5C34.7696 27.9583 33.7917 30.3151 32.0534 32.0534C30.3151 33.7917 27.9583 34.7696 25.5 34.7727V34.7727Z",
    fill: "#455A64"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.457151d49a48d2e8a7d15c7c520ce48e.svg";
export { ForwardRef as ReactComponent };